package com.arena_web.data.http

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ApiResponse<T>(
    @SerialName("code")
    val code: Int,
    @SerialName("data")
    val data: T? = null,
    @SerialName("errors")
    val errors: List<String>? = null,
)

@Serializable
data class PaginatedResponse<T>(
    @SerialName("total")
    val total: Int,
    @SerialName("count")
    val count: Int,
    @SerialName("page")
    val page: Int,
    @SerialName("pageSize")
    val pageSize: Int,
    @SerialName("hasNextPage")
    val hasNextPage: Boolean,
    @SerialName("items")
    val items: List<T>,
    @SerialName("appliedFilterId")
    val appliedFilterId: Int? = null,
)

@Serializable
data class PaginationInfo(
    @SerialName("page")
    val page: Int,
    @SerialName("limit")
    val limit: Int,
    @SerialName("total")
    val total: Int,
    @SerialName("totalPages")
    val totalPages: Int,
    @SerialName("hasNext")
    val hasNext: Boolean,
    @SerialName("hasPrevious")
    val hasPrevious: Boolean,
)

@Serializable
data class ValidationError(
    @SerialName("field")
    val field: String,
    @SerialName("message")
    val message: String,
    @SerialName("code")
    val code: String,
)

@Serializable
data class ErrorResponse(
    @SerialName("success")
    val success: Boolean = false,
    @SerialName("message")
    val message: String,
    @SerialName("code")
    val code: String? = null,
)
